import { FinalAcceptApplicantModalProps } from "./FinalAcceptApplicantModal.types";
import { useTranslation } from "react-i18next";
import { StatusCodes } from "http-status-codes";
import { finalAcceptApplicant } from "../../../../../../../../Requests/internship-requests";
import {
	NOTIFICATION_TYPES,
	openNotification,
} from "../../../../../../../Notifications/NotificationsUtils";
import ConfirmationModal from "../../../../../../../../Containers/ConfirmationModal";
import { useState } from "react";

export const FinalAcceptApplicantModal = (
	props: FinalAcceptApplicantModalProps
) => {
	const { t } = useTranslation();
	const [spinning, setSpinning] = useState(false);

	const handleFinalAcceptApplicant = (item: any) => {
		setSpinning(true);

		finalAcceptApplicant(item.internshipId, item.id)
			.then(async () => {
				await props.invalidateApplicantsQueries();
				openNotification(
					t("students.acceptApplicant"),
					t("students.successAcceptApplicantMessage"),
					NOTIFICATION_TYPES.SUCCESS
				);
			})
			.catch((ex) => {
				openNotification(
					t("students.acceptApplicant"),
					t(
						ex.status === StatusCodes.FORBIDDEN
							? "students.errorAcceptApplicantExceededMessage"
							: ex.status === StatusCodes.CONFLICT
							? "students.errorAcceptApplicantHasCompanyEnrollmentMessage"
							: "students.errorAcceptApplicantMessage"
					),
					NOTIFICATION_TYPES.ERROR
				);
			})
			.finally(() => {
				setSpinning(false);
				props.setModalVisibility(false);
			});
	};

	return (
		<ConfirmationModal
			modalText={
				props.selectedApplicant.availablePositions !== 0
					? t("students.acceptStudentMessage") +
					  props.selectedApplicant.name +
					  t("students.acceptStudentMessage2")
					: t("students.acceptStudentExceeded") +
					  props.selectedApplicant.internshipName +
					  t("students.acceptStudentExceeded2")
			}
			handleFunction={() => handleFinalAcceptApplicant(props.selectedApplicant)}
			modalVisibility={props.modalVisibility}
			title=""
			changeModalVisibility={() => props.setModalVisibility(false)}
			spinning={spinning}
			divStyle={{}}
		/>
	);
};
